import React from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import Badge from 'apps/web_forms/components/badges/Badge';
import RenderButtons from 'apps/web_forms/components/commons/RenderButtons';
import { NotificationType } from 'apps/web_forms/contexts/NotificationBarContext';
import useFormPadding from 'apps/web_forms/hooks/useFormPadding';
import useReactWrapperPadding from 'apps/web_forms/hooks/useReactWrapperPadding';
import { COLORS, ids } from 'apps/web_forms/utils/constants';

import {
  FlexContainer,
  LeftSectionDiv,
  LeftWrapperDiv,
  MainTextP,
  NotificationBarDiv,
  RightSection,
} from './styles';

const { SUCCESS, WARNING, ERROR, INFO } = NotificationType;

const NotificationBar = ({
  isShown,
  notificationText,
  type,
  buttons,
  rightContents,
  alignLeft,
}) => {
  const reactWrapperPadding = useReactWrapperPadding();
  const formpadding = useFormPadding();
  const sidePadding = `calc(${reactWrapperPadding} + ${formpadding})`;

  const leftAndMain = (
    <>
      <LeftSectionDiv>
        {type === INFO && (
          <Badge
            id={ids.NotificationBarIds.InfoBadge}
            className={'badge-adjustment'}
            bgColor={COLORS.green}
          >
            !
          </Badge>
        )}
      </LeftSectionDiv>
      <MainTextP>{notificationText}</MainTextP>
    </>
  );

  const styledButtons = buttons?.map((button) => { 
    return {
      ...button,
      className: clsx(button?.className, 'button-adjustment'),
    }
  });

  const fullContents = (
    <>
      {alignLeft ? (
        <LeftWrapperDiv>{leftAndMain}</LeftWrapperDiv>
      ) : (
        { leftAndMain }
      )}
      <RightSection>
        {rightContents}
        <RenderButtons buttons={styledButtons}/>
      </RightSection>
    </>
  );

  return (
    isShown && (
      <NotificationBarDiv
        className={`notification-bar ${type}`}
        reactWrapperPadding={reactWrapperPadding}
      >
        <FlexContainer sidePadding={sidePadding}>{fullContents}</FlexContainer>
      </NotificationBarDiv>
    )
  );
};

NotificationBar.propTypes = {
  isShown: PropTypes.bool.isRequired,
  notificationText: PropTypes.string.isRequired,
  type: PropTypes.oneOf([SUCCESS, WARNING, ERROR, INFO]),
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      filled: PropTypes.bool,
      disabled: PropTypes.bool,
    })
  ),
  rightContents: PropTypes.node,
  alignLeft: PropTypes.bool,
};

NotificationBar.defaultProps = {
  type: NotificationType.SUCCESS,
  buttons: [],
  rightContents: undefined,
  alignLeft: true,
};

export default NotificationBar;
